// extracted by mini-css-extract-plugin
module.exports = {"aircraftNameActive":"aircraftNameActive-31mRH","wrapper":"wrapper-2XkNh","airline":"airline-mMNeY"};